export function ProgressBar({ value, label = true }: { value: number; label?: boolean }) {
  const safeValue = Math.min(100, Math.max(0, value));
  return (
    <div className="progress-wrap" aria-label={`进度 ${safeValue}%`}>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${safeValue}%` }} />
      </div>
      {label ? <span>{safeValue}%</span> : null}
    </div>
  );
}
